import { render, staticRenderFns } from "./ShowIntegration.vue?vue&type=template&id=2c6e1aeb&"
import script from "./ShowIntegration.vue?vue&type=script&lang=js&"
export * from "./ShowIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports